export default __webpack_public_path__ + "static/acq-category-3-80065780c31727bce5c2308c9f4f54de.jpg";